import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Security } from "src/api/models";
import { SecurityMappingService } from "src/api/services";
import {sanitizeForm} from "../../../../../core/utils/form-clean";

@Component({
  selector: "app-edit-security-data",
  // imports: [],
  templateUrl: "./edit-security-data.component.html",
  styleUrl: "./edit-security-data.component.css",
  standalone: false,
})
export class EditSecurityDataComponent implements OnInit {
  formData: any = {
    securityType: "",
  };
  isLoading: boolean = false;
  securityInfo: Security | any;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _securityMappingService: SecurityMappingService,
    public _messageService: MessageService
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.securityData) {
      this.formData.securityType = this.config.data.securityData.securityType;
      this.securityInfo = this.config.data.securityData;
    }
  }
  onUpdate() {
    const payload: Security = {
      issuerId: this.securityInfo.issuerId,
      issuerName: this.securityInfo.issuerName,
      reason: "Updated attributes successfully",
      securityId: this.securityInfo.securityId,
      securityType: this.formData.securityType,
      totalCount: this.securityInfo.totalCount,
    };
    const cleaned = sanitizeForm(payload);
    this.isLoading = true;
    this._securityMappingService.updateSecurity(cleaned).subscribe({
      next: (updatedInsider) => {
        this._messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Issuer updated successfully.",
        });

        this.ref.close(updatedInsider);
      },
      error: (error) => {
        this.isLoading = false;
        console.error("Update failed:", error);
        this._messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to update issuer.",
        });
      },
      complete: () => {
        this.isLoading = false;
        this.ref.close({ refresh: true });
      },
    });
  }

  onCancel() {
    this.ref.close();
  }
}
